import { useEffect, useState } from "react";
import Logo from "../components/Logo";
import LanguageSwitcher from "../components/LanguageSwitcher";
import ExperienceCard from "../components/ExperienceCard";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";

export default function Home() {
  const { t } = useLang();
  const { user } = useAuth();
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/experiences")
      .then((res) => setExperiences(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="home-page">
      <div className="mx-auto max-w-6xl px-6 md:px-12 pt-7 md:pt-12">
        {/* Mobile-only top bar (desktop has TopNav) */}
        <div className="flex items-center justify-between md:hidden">
          <Logo size="md" />
          <LanguageSwitcher />
        </div>

        <header className="mt-9 md:mt-4">
          <p className="text-[10px] tracking-[0.45em] uppercase font-bold text-brand-tan">
            {t("home_kicker")} · Temporada I
          </p>
          <h1 className="font-serif text-4xl md:text-6xl leading-[1.05] text-brand-brown mt-3">
            {t("home_title")}
          </h1>
          <p className="text-sm md:text-base text-brand-brown/70 mt-3 max-w-[36ch] md:max-w-[52ch] leading-relaxed">
            {user?.name && `${t("good_morning")}, ${user.name}. `}
            {t("welcome_title")} — {t("chapters_count")}.
          </p>
        </header>

        <section className="mt-10 md:mt-14 pb-6 md:pb-16">
          {loading ? (
            <Skeleton />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-9 md:gap-10 stagger">
              {experiences.map((exp) => (
                <ExperienceCard key={exp.id} exp={exp} />
              ))}
            </div>
          )}
        </section>
      </div>

      <Footer />
    </div>
  );
}

function Skeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-9 md:gap-10">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="aspect-[4/5] w-full rounded-2xl bg-brand-ivory animate-pulse"
        />
      ))}
    </div>
  );
}
